import t from "../../../../helpers/t";
import FormItem from "../../../../components/FormItem";
import React, { useEffect, useState } from "react";

const LocationsChange = (props) => {
  const { visualInspection, locations, setLocations, dispatch } = props;
  const [selectedLocations, setSelectedLocations] = useState(locations);
  useEffect(() => {
    change();
  }, [selectedLocations]);
  const addLocations = (location) => {
    let locationIds = [];
    selectedLocations.map((sel) => {
      locationIds.push({
        id: sel.id,
        name: sel.name,
        description: sel.description,
      });
    });
    locationIds.push({
      id: location.id,
      name: location.name,
      description: location.description,
    });
    let clone = {};
    Object.assign(clone, locations);
    clone = locationIds;
    setLocations(clone);
  };
  const change = () => {
    let clone = {};
    Object.assign(clone, locations);
    let locationIds = [];
    selectedLocations.map((sel) => {
      locationIds.push({
        id: sel.id,
        name: sel.name,
        description: sel.description,
      });
    });
    clone = locationIds;
    setLocations(clone);
  };

  const onRemoveLocation = (index) => {
    const newLocations = selectedLocations.slice(0);
    newLocations.splice(index, 1);
    setSelectedLocations(newLocations);
    change();
  };

  const fields = {
    fieldMap: {
      id: {
        label: t("id"),
        number: "1",
        class: "inb-select-width-1",
        type: "default",
        style: { maxWidth: "20%", padding: 0 },
      },
      name: {
        label: t("name"),
        number: "2",
        class: "inb-select-width-3",
        type: "default",
        style: { maxWidth: "35%", padding: 0 },
      },
      description: {
        label: t("description"),
        number: "3",
        class: "inb-select-width-3",
        type: "default",
      },
    },
    fieldNames: ["id", "name", "description"],
  };
  const searchParams = {
    param: "q",
    checkFields: ["name"],
  };
  return (
    <>
      <FormItem
        name="locations"
        type="inboomaSelect"
        id={
          "visual_inspection_locations_" +
          (typeof visualInspection.id !== "undefined" ? visualInspection.id : "new")
        }
        sortBy={"name"}
        sortDirection={"asc"}
        advanced={true}
        placeholder={t("select_${a}", { a: t("location") })}
        selectedItems={selectedLocations}
        setSelectedItems={setSelectedLocations}
        onChangeHandler={addLocations}
        dispatch={dispatch}
        container="location-vcard"
        extraStyle={{ maxWidth: "750px" }}
        multiSelect={true}
        onReset={onRemoveLocation}
        fields={fields}
        searchParams={searchParams}
        model={"location"}
        label={t("location", null, "capital")}
        helpText={t("select_${a}", { a: t("location") }) + " " + t("or leave empty for all")}
        mediumWidth={12}
        smallWidth={12}
      />
    </>
  );
};
export default LocationsChange;
